const colors = [
    "#9A6649",
    "#578FA2",
    "#D29873",
    "#F9AC56",
    "#004166",
    "#429A8E",
    "#9AA077",
    "#892B64",
    "#D07062",
    "#93868F",
]
export const getColorFromId = (id: string) =>
    colors[(id.split("").reduce((acc, cur) => acc + cur.charCodeAt(0), 0) || 0) % colors.length]

export const obfuscateEmail = (email?: string) =>
    email?.replace(/^(.{2})([^@]+)(.)@(.{2}).+(.)$/, "$1***$3@$4***$5")
